module.exports = __webpack_public_path__ + "img/7-whale_v8e_loading.0db55cf1.jpg";